import { showError } from 'utils/messages';

import Base from 'app/views/base';
import LoaderView from 'app/views/loader_view';

import BankAccountDetailsView from 'app/components/pages/billing/payment_methods/bank_account_details';
import CreditCardDetailsView from 'app/components/pages/billing/payment_methods/credit_card_details';
import PaymentMethodTypeSelectionView from 'app/components/pages/billing/payment_methods/type_selection_view';

import tmpl from './details_template';

export default Base.extend({
  compiledTemplate: tmpl,

  initialize({ user }) {
    this.user = user;
    this.listenTo(this.model, 'change sync error', this.render);
    this.listenTo(this.model, 'newPaymentMethod', () => this.user.fetch()); // new user's recharge amt/thresh is null to start

    this.addSubview('primaryLoader', '#primary_loader', new LoaderView({ model: this.model, cssClass: 'my-4' }));
    this.addSubview('secondaryLoader', '#secondary_loader', new LoaderView({ model: this.model, cssClass: 'my-4' }));
  },

  beforeRender() {
    if (this.model.firstFetchSuccess) {
      this.addSubview('primaryDetails', '#primary_payment_method', this.subviewInstanceForPriority(this.model.primary(), 'primary'));
      this.addSubview('secondaryDetails', '#secondary_payment_method', this.subviewInstanceForPriority(this.model.secondary(), 'secondary'));
    }
  },

  afterRender() {
    this.$('[data-toggle="tooltip"]').tooltip({ html: true });
    if (this.model.firstFetchSuccess && !this.model.hasAPaymentMethod()) {
      showError('Your account does not currently have a primary payment method on file.' +
      ' Please add a bank or credit card in order to ensure uninterrupted usage for any requests or api usage.', { noClose: true });
    }
  },

  subviewInstanceForPriority(model, priority) {
    const priorityPaymentAttrs = {
      model,
      paymentMethods: this.model,
      priority,
      user: this.user,
    };

    if (model && model.get('object') === 'CreditCard') {
      return new CreditCardDetailsView(priorityPaymentAttrs);
    } else if (model && model.get('object') === 'BankAccount') {
      return new BankAccountDetailsView(priorityPaymentAttrs);
    }

    return new PaymentMethodTypeSelectionView({
      model: this.model,
      priority,
      user: this.user,
    });
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/billing/payment_methods/details_view.js